import { publicFormUrl } from './contracts';

const escape = value =>
  String(value == null ? '' : value).replace(
    /[&<>"']/g,
    character =>
      ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[
        character
      ])
  );
export function rawFormMarkup(id, document, apiUrl) {
  const design = document.design;
  const inputStyle =
    'box-sizing:border-box;width:100%;min-height:44px;padding:10px 12px;border:1px solid currentColor;border-radius:6px;font:inherit';
  const fields = document.fields
    .map(field => {
      const name = escape(field.key);
      const label = escape(field.label);
      const required = field.required ? ' required' : '';
      if (field.type === 'hidden')
        return `<input type="hidden" name="${name}" value="">`;
      let input;
      if (field.type === 'checkbox' || field.type === 'consent')
        input = `<input type="checkbox" name="${name}" value="1"${required}> ${label}`;
      else if (field.type === 'select')
        input = `${label}<select name="${name}" style="${inputStyle}"${required}><option value="">${escape(
          field.placeholder || 'Select an option'
        )}</option>${field.options
          .map(
            option =>
              `<option value="${escape(option)}">${escape(option)}</option>`
          )
          .join('')}</select>`;
      else if (field.type === 'textarea')
        input = `${label}<textarea name="${name}" placeholder="${escape(
          field.placeholder
        )}" style="${inputStyle}"${required}></textarea>`;
      else
        input = `${label}<input type="${
          field.type === 'phone' ? 'tel' : escape(field.type)
        }" name="${name}" placeholder="${escape(
          field.placeholder
        )}" style="${inputStyle}"${required}>`;
      return `<label style="display:block;margin:16px 0">${input}</label>`;
    })
    .join('\n');
  return `<form action="${escape(
    apiUrl.replace(/\/$/, '')
  )}/studio/public/forms/${encodeURIComponent(
    id
  )}/submit" method="post" style="max-width:576px;padding:32px;font-family:system-ui,sans-serif;background:${escape(
    design.backgroundColor || 'white'
  )};border-radius:16px">
<h2>${escape(design.heading)}</h2><p>${escape(design.description)}</p>
${fields}
<label style="position:absolute;left:-10000px" aria-hidden="true">Leave empty<input name="website" tabindex="-1" autocomplete="off"></label>
<button type="submit" style="width:100%;padding:14px;border:0;border-radius:10px;background:${escape(
    design.submitColor || design.accentColor
  )};color:${escape(
    design.submitTextColor
  )};font:inherit;font-weight:600">${escape(design.submitLabel)}</button>
<p>${escape(design.footerText)}</p></form>`;
}

export function popupMarkup(id, name, button) {
  const url = publicFormUrl(id);
  const label = escape(button.label || 'Open the form');
  // The parent only hosts an iframe. All modal chrome is rendered by the Groove kit inside it.
  return `<button type="button">${label}</button>
<script>(function(){
var trigger=document.currentScript.previousElementSibling;
trigger.addEventListener('click',function(){
  var frame=document.createElement('iframe');
  var src=${JSON.stringify(
    url
  )}+'&popup=1&parentOrigin='+encodeURIComponent(location.origin);
  frame.src=src;frame.title=${JSON.stringify(name).replace(/</g, '\\u003c')};
  frame.style.cssText='position:fixed;inset:0;width:100%;height:100%;border:0;z-index:2147483000';
  var previousOverflow=document.body.style.overflow;document.body.style.overflow='hidden';
  function close(){frame.remove();document.body.style.overflow=previousOverflow;window.removeEventListener('message',receive);trigger.focus();}
  function receive(event){if(event.source!==frame.contentWindow||event.origin!==new URL(src).origin)return;
    if(event.data&&event.data.type==='groovemail:close-popup')close();
    if(event.data&&event.data.type==='groovemail:redirect'&&/^https?:\\/\\//i.test(event.data.url)){close();location.assign(event.data.url);}}
  window.addEventListener('message',receive);document.body.appendChild(frame);
});})();<\/script>`;
}
